import { AInput } from "@/admin/form/Fields.tsx";
import { googleTagManagerMutation } from "@/admin/marketing/googleTagManagerQuery.ts";
import { WModalForm } from "@/components/forms/WModalForm.tsx";
import { WTextField } from "@/components/forms/WTextField.tsx";
import { controllerProps, formPropsToAriaProps } from "@/components/forms/ariaController.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { Controller, type SubmitHandler, useForm } from "react-hook-form";

interface TrackingInputs {
    key: string;
}

export function UpdateGoogleTagManagerKeyModal({ value }: { value: string }) {
    //#region Hooks
    const updateMutation = useStandardMutation(googleTagManagerMutation);
    //#endregion

    const onSubmit: SubmitHandler<TrackingInputs> = async (inputs) => {
        const { key } = inputs;

        await updateMutation.mutateAsync({
            gtm_key: key,
        });
    };

    const form = useForm<TrackingInputs>({
        mode: "onBlur",
        reValidateMode: "onBlur",

        defaultValues: {
            key: value,
        },
    });

    const { control } = form;

    return (
        <WModalForm title="Update Google Tag Manager key" label="Update" form={form} onSubmit={onSubmit}>
            <Controller
                control={control}
                name="key"
                {...controllerProps({ isRequired: true })}
                render={(props) => (
                    <WTextField {...formPropsToAriaProps(props)} autoFocus headless block label="GTM key">
                        <AInput />
                    </WTextField>
                )}
            />
        </WModalForm>
    );
}
